import { render, staticRenderFns } from "./AddProductsToPortfolioModalContent.vue?vue&type=template&id=812553ca&scoped=true&"
import script from "./AddProductsToPortfolioModalContent.vue?vue&type=script&lang=js&"
export * from "./AddProductsToPortfolioModalContent.vue?vue&type=script&lang=js&"
import style0 from "./AddProductsToPortfolioModalContent.vue?vue&type=style&index=0&id=812553ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812553ca",
  null
  
)

export default component.exports